export default {
	mounted(store){}
}
